import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useOutletContext} from "react-router-dom";

import ValueLendingValueInfo from "../../component/ValueLendingValueInfo";
import {selectAddressSelected} from "../../redux/addressSlice";
import {selectSegment} from "../../redux/objectParametersSlice";
import {validateFormThunk} from "../../redux/objectParametersThunk";
import ErrorMessageContainer from "./ErrorMessageContainer";
import ObjectInputs from "./ObjectInputs";
import PersistenceFinalMessage from "./PersistenceFinalMessage";
import SnapshotMessage from "./SnapshotMessage";

/**
 * @returns {React.JSX.Element}
 */
function TabObjectProperties() {
    const {displayStatus} = useOutletContext();

    const dispatch = useDispatch();
    const segment = useSelector(selectSegment);
    const address = useSelector(selectAddressSelected);
    useEffect(() => {
        if (segment && address) {
            dispatch(validateFormThunk());
        }
    }, [dispatch, segment, address]);

    return (
        <>
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <ValueLendingValueInfo />
            <ErrorMessageContainer />
            <ObjectInputs displayStatus={displayStatus} />
        </>
    );
}

export default TabObjectProperties;
